import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

interface PostDiveMapProps {
  latitude: number;
  longitude: number;
  height?: number;
}

/**
 * Compact, non-interactive-feeling site map for a feed card — same dual tile-layer
 * treatment as the full map on DiveDetail, but smaller and with the default marker
 * rather than DiveDetail's dive-type-colored icon, which isn't worth the weight here.
 */
const PostDiveMap: React.FC<PostDiveMapProps> = ({ latitude, longitude, height = 160 }) => {
  useEffect(() => {
    try {
      const prototype = L.Icon.Default.prototype as any;
      if (prototype._getIconUrl) {
        delete prototype._getIconUrl;
      }
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
        iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
      });
    } catch (error) {
      console.warn('Failed to initialize Leaflet icons:', error);
    }
  }, []);

  return (
    <Box sx={{ height, borderRadius: 2, overflow: 'hidden', mb: 1 }}>
      <MapContainer
        style={{ height: '100%', width: '100%' }}
        zoom={11}
        center={[latitude, longitude]}
        scrollWheelZoom={false}
        dragging={false}
        doubleClickZoom={false}
        zoomControl={false}
        attributionControl={false}
      >
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          opacity={0.3}
        />
        <Marker position={[latitude, longitude]} />
      </MapContainer>
    </Box>
  );
};

export default PostDiveMap;
